import { ArrowRight, Star } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface SectionProps {
  children: ReactNode;
  className?: string;
  innerClassName?: string;
  id?: string;
}

export function PmlSection({
  children,
  className,
  innerClassName,
  id,
}: SectionProps) {
  return (
    <section
      id={id}
      className={cn("w-full px-4 py-12 md:px-12 md:py-16", className)}
    >
      <div className={cn("mx-auto w-full max-w-[1190px]", innerClassName)}>
        {children}
      </div>
    </section>
  );
}

interface PmlCtaButtonProps {
  href: string;
  children: ReactNode;
  className?: string;
}

export function PmlCtaButton({ href, children, className }: PmlCtaButtonProps) {
  return (
    <a
      href={href}
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-full bg-[#1F2DFF] px-6 py-3.5 text-[15px] font-semibold text-white shadow-sm transition hover:bg-[#1721d6]",
        className
      )}
    >
      <span>{children}</span>
      <span className="flex size-6 items-center justify-center rounded-full bg-white/15">
        <ArrowRight className="size-4" aria-hidden="true" />
      </span>
    </a>
  );
}

interface StarsProps {
  count?: number;
  className?: string;
}

export function Stars({ count = 5, className }: StarsProps) {
  return (
    <div className={cn("flex items-center gap-0.5", className)}>
      {Array.from({ length: count }).map((_, i) => (
        <Star
          key={i}
          className="size-4 fill-emerald-500 stroke-emerald-500"
          aria-hidden="true"
        />
      ))}
    </div>
  );
}

export function VerifiedBadge() {
  return (
    <span className="text-grey-600 inline-flex items-center gap-1 text-[11px]">
      <svg
        viewBox="0 0 16 16"
        fill="none"
        className="size-3.5 fill-emerald-500 stroke-white"
        aria-hidden="true"
      >
        <path d="M8 0l1.8 1.6 2.4-.4.8 2.3 2.2 1.1-1 2.2 1 2.2-2.2 1.1-.8 2.3-2.4-.4L8 16l-1.8-1.6-2.4.4-.8-2.3L.8 11.4l1-2.2-1-2.2L3 5.9l.8-2.3 2.4.4L8 0z" />
        <path
          d="M5 8l2 2 4-4"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          stroke="white"
          fill="none"
        />
      </svg>
      Verified Review
    </span>
  );
}
